















import { Component, Prop, Vue } from 'vue-property-decorator';
import { redirectToLocation } from '@/commons/redirectManager';
import user from '@/store/modules/user';
import Logo from '@/components/UI/Logo.vue';
import LogoFirma from '@/components/SvgIcons/LogoFirma.vue';
import { AppWarning } from '@/store/models';
import store from '@/store';

@Component({
  components: {
    Logo,
    LogoFirma,
  },
})
export default class CartHeader extends Vue {
  @Prop() private count!: number;
  @Prop() private title!: string;

  get isLogged(): boolean {
    return user.isLoggedin;
  }

  get appWarnings(): AppWarning[] {
    return store.getters.warnings;
  }

  get isCart() {
    return (
      this.$route.params.step === 'cart' ||
      typeof this.$route.params.step === 'undefined'
    );
  }

  get step() {
    return this.$route.params.step;
  }

  private editCart() {
    this.$router.push({ path: '/' });
  }

  private closeCart() {
    redirectToLocation('/');
  }

  private redirectToHome() {
    redirectToLocation('/');
  }

  private stepBack() {
    const currentStep = this.$route.params.step;
    switch (currentStep) {
      case 'login':
        this.$router.push({ path: '/' });
        break;
      case 'shipping':
        if (user.isLoggedin) {
          this.$router.push({ path: '/' });
        } else {
          this.$router.push({ path: '/login' });
        }
        break;
      case 'invoice':
        if (user.isLoggedin) {
          this.$router.push({ path: '/' });
        } else {
          this.$router.push({ path: '/shipping' });
        }
        break;
      default:
        return false;
    }
  }
}
